<template>
  <div class="checklist">
    <p class="instruction" v-if="instruction">{{ instruction }}</p>

    <div v-if="checklistItems.length">
      <div class="accordions">
        <Accordion
          v-for="(accordion, index) in checklistItems"
          :key="accordion.id"
          :id="accordion.id"
          :title="`${index + 1}. ${accordion.title}`"
          :description="accordion.description"
          :open="isAccordionOpen(accordion.id)"
          :state="getItemState(accordion.id)"
          :item="accordion"
          @stateChange="handleAccordionStateChange"
          @itemStateChange="handleItemStateChange"
        />
      </div>
      <span
        v-tooltip="'Bitte beantworten Sie alle Fragen'"
        v-if="!allStatesSet()"
      >
        <NavigationButton
          :to="{ path: '/', query: { type: 'evaluation', id } }"
          :disabled="!allStatesSet()"
        >
          Auswerten
        </NavigationButton>
      </span>

      <NavigationButton
        :to="{ path: '/', query: { type: 'evaluation', id } }"
        v-if="allStatesSet()"
      >
        Auswerten
      </NavigationButton>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import "whatwg-fetch";
import Accordion from "@/components/Accordion.vue";
import NavigationButton from "@/components/NavigationButton.vue";

export default {
  name: "Checklist",

  components: {
    Accordion,
    NavigationButton
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data: () => {
    return {
      checklistItems: [],
      merges: false,
      instruction: ""
    };
  },

  computed: {
    internalId() {
      return `checklist-${this.id}`;
    }
  },

  mounted() {
    this.registerChecklist({ id: this.internalId });
    this.loadChecklistItems();
  },

  methods: {
    ...mapMutations([
      "registerChecklist",
      "registerAccordion",
      "setAccordionState",
      "setItemState"
    ]),
    async loadChecklistItems() {
      try {
        const response = await fetch(`../assets/${this.internalId}.json`);
        const {
          items = [],
          merges = false,
          instruction = ""
        } = await response.json();

        this.checklistItems = items;
        this.merges = merges;
        this.instruction = instruction;
        this.checklistItems.forEach(accordion =>
          this.registerAccordion({
            checklistId: this.internalId,
            id: accordion.id
          })
        );
      } catch (erorr) {
        // eslint-disable-next-line
        console.error(erorr);
      }
    },
    handleAccordionStateChange({ id, open }) {
      this.setAccordionState({
        checklistId: this.internalId,
        id,
        open,
        closeOthers: true
      });
      this.$forceUpdate();
    },
    handleItemStateChange({ id, state, origin }) {
      this.setItemState({
        id: this.generateItemId(id, origin),
        value: state,
        merges: this.merges
      });
      this.$forceUpdate();
    },
    isAccordionOpen(accordionId) {
      return this.$store.getters.isAccordionOpen(this.internalId, accordionId);
    },
    getItemState(accordionId) {
      return this.$store.getters.accordionState(
        this.generateItemId(accordionId),
        { merges: this.merges }
      );
    },
    generateItemId(accordionId, checklistId = null) {
      return `${checklistId || this.internalId}/${accordionId}`;
    },
    allStatesSet() {
      if (this.merges) {
        const itemIds = this.checklistItems.map(item => item.id);
        return (
          Object.entries(this.$store.getters.checklistStatesByItemIds(itemIds))
            .length === this.checklistItems.length
        );
      }

      const allStates = this.$store.getters.checklistStates(this.internalId);
      return Object.entries(allStates).length === this.checklistItems.length;
    }
  }
};
</script>

<style scoped lang="scss">
.instruction {
  font-style: italic;
  text-align: left;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #4d4d4d;
}

.accordions {
  margin-bottom: 40px;
}
</style>
